import { render, staticRenderFns } from "./UnderSupervision.vue?vue&type=template&id=2837579e&scoped=true&"
import script from "./UnderSupervision.vue?vue&type=script&lang=js&"
export * from "./UnderSupervision.vue?vue&type=script&lang=js&"
import style0 from "./UnderSupervision.vue?vue&type=style&index=0&id=2837579e&prod&lang=scss&"
import style1 from "./UnderSupervision.vue?vue&type=style&index=1&id=2837579e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2837579e",
  null
  
)

export default component.exports